export const config = {
    // API_URI: "https://zoobbe-board.onrender.com",
    // API_URI: "https://api-qcqo.onrender.com",

    // API_URI: "https://zoobbe-beta.onrender.com",
    // API_URI: "https://api-v1.zoobbe.com",
    API_URI: window.location.hostname === 'zoobbe.com'
        ? 'https://api.zoobbe.com'
        : `${window.location.origin}`,

    // API_URI: "http://localhost:8000",


    DOMAIN: "https://zoobbe.com",
    IS_BETA: false,
    GOOGLE_AUTH_CLIENT_ID: "39531044046-0lrtdc7ojrq119nhg7fq14t8m27ae0so.apps.googleusercontent.com",
    GITHUB_CLIENT_ID: "Ov23liUzCyNVGc0d98nY", // Replace with actual GitHub OAuth App Client ID
    PUSH_NOTIFICATION_VAPID_KEY_PAIR_ID: "BGeuQBwitmUXTSwhzhDt3xihBHyLDYSOZPXa7AXuIHWvK_7nv6bHM3WDDdlg_nMABtjigrQuOUN1iqmJtOcywkY",
    CLOUDFLARE_RECAPTCHA_SITE_KEY: "0x4AAAAAABCKhHsMLzF3gBUs",
    TRELLO_AUTH_API_KEY: "952269ee902bbd2a413c4890094365f2",
    STRIPE_PUBLIC_KEY: "pk_test_51Ldmn6K0cSs6yAeTLETj2DdPhCbbWMGy9lPEbMFF6POU8DODiJjMCEJgLrMfmN7WD3k96KkDs7nkQWK5UDPQANFp00aRx7H5Pn",
    FREE_COLLABORATORS_LIMIT: 15,
    APP_VERSION: "v0.0.1",
    // API_URI: "https://api.zoobbe.com", 

    // White Label Configuration
    DISABLE_WHITE_LABEL_PAYMENTS: false,

    // Global OAuth Configuration (for main Zoobbe domain)
    ENABLE_GOOGLE_AUTH: true, // Default: enabled for main Zoobbe domain
    ENABLE_GITHUB_AUTH: true, // Default: enabled for main Zoobbe domain
};
